import { concatClassnames } from "shared/utils/concatClassnames";
import SamplesHeader from "../samples-header";
import SamplesOptions from "../samples-options";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import SamplesFooter from "../samples-footer";
import { useState } from "react";

interface Props {
  className?: string;

  selectedSample: CategoryStandardProduct | undefined;
  setSelectedSample: (sample: CategoryStandardProduct) => void;
}
const SamplesConfigurator = ({
  className,
  setSelectedSample,
  selectedSample,
}: Props) => {
  const [selectedSamples, setSelectedSamples] = useState<
    CategoryStandardProduct[]
  >([]);

  return (
    <div className={concatClassnames("gg-bg-grey-500", className)}>
      <div className="gg-p-5 sm:gg-px-8 sm:gg-py-7">
        <SamplesHeader
          className="gg-mb-5"
          setSelectedSamples={setSelectedSamples}
          selectedSamples={selectedSamples}
        />
        <SamplesOptions
          selectedSamples={selectedSamples}
          setSelectedSamples={setSelectedSamples}
          selectedSample={selectedSample}
          setSelectedSample={setSelectedSample}
        />
      </div>
      <SamplesFooter
        setSelectedSamples={setSelectedSamples}
        selectedSamples={selectedSamples}
        className="gg-p-5 sm:gg-px-8 sm:gg-py-7"
      />
    </div>
  );
};
export default SamplesConfigurator;
